export var BART_ROOM_TYPE_LABELS_OBJ = {
  FMTRPL: 'dashboard.bookings.familyRoom',
  FMQUAD: 'dashboard.bookings.familyRoom',
  DOUBLE: 'dashboard.bookings.doubleRoom',
  LOWDBL: 'dashboard.bookings.doubleRoom',
  DIS: 'dashboard.bookings.doubleRoom',
  FAM: 'dashboard.bookings.familyRoom',
  TB: 'dashboard.bookings.familyRoom',
  TBT: 'dashboard.bookings.twinRoom',
  TWIN: 'dashboard.bookings.twinRoom',
  DB: 'dashboard.bookings.doubleRoom'
};
export var IDV_INITIAL_DATA = {
  passed: false,
  bookingReference: ''
};
export var IDV_STATUS_KEY = 'idvData';